import { render, staticRenderFns } from "./menu-main.vue?vue&type=template&id=7631571d&scoped=true"
import script from "./menu-main.vue?vue&type=script&lang=js"
export * from "./menu-main.vue?vue&type=script&lang=js"
import style0 from "./menu-main.vue?vue&type=style&index=0&id=7631571d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7631571d",
  null
  
)

export default component.exports